import { colorVariables } from './colorVars.js';
import { cityBounds } from './boundaries/city-boundaries.js';
import { supervisorsBounds } from './boundaries/supervisors-boundaries.js';
import { congressionalBounds } from './boundaries/congressional-boundaries.js';

import {
  CITY_LAYER,
  SUPERVISORS_LAYER,
  CONGRESSIONAL_LAYER,
} from './constants.js';

export function createStaticMapUrls(geocoderResult, divisions) {
  let coordinates = geocoderResult.center;
  let cityName = divisions['locality'].id;

  let mapboxStyle = 'clc85okov000a14jy545d5ly3';

  let lookup = {
    congressional: divisions['federal'].id,
    supervisors: divisions['county'].id,
  };

  // console.log(lookup);

  // get boundaries
  let cityBoundaries = getBoundaries(cityName, 'city');
  let congressionalBoundaries = getBoundaries(
    lookup['congressional'],
    'congressional'
  );
  let supervisorsBoundaries = getBoundaries(
    lookup['supervisors'],
    'supervisors'
  );

  function getBoundaries(n, type) {
    if (type == 'city') {
      if (cityBounds(n)) {
        return cityBounds(n);
      } else {
        return cityBounds('Unincorporated');
      }
    } else if (type == 'congressional') {
      if (congressionalBounds(n)) {
        return congressionalBounds(n);
      } else {
        // console.log('Not found'); // console log is for testing
      }
    } else if (type == 'supervisors') {
      if (supervisorsBounds(n)) {
        return supervisorsBounds(n);
      } else {
        //console.log('Not found'); // console log is for testing
      }
    }
  }

  let api =
    'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

  let screenWidth = window.innerWidth;

  // LAYERS AND STYLINGS
  let padding;
  let breakpoint = 767;
  if (screenWidth >= breakpoint) {
    padding = '60,30,60,30'; // desktop
  } else {
    padding = '30,20,160,20'; //mobile
  }

  let cityColor = colorVariables('city');
  let countyColor = colorVariables('county');
  let congressionalColor = colorVariables('fed');
  let marker = 'pin-l+000';

  let mapWidth;
  let mapHeight;
  if (screenWidth >= breakpoint) {
    mapWidth = 400;
    mapHeight = 500;
  } else {
    mapWidth = 400;
    mapHeight = 600;
  }

  let cityBoundariesLayer = {
    'id': 'lac-boundary-fill-layer',
    'type': 'line',
    'source': 'composite',
    'source-layer': CITY_LAYER,
    'filter': ['==', 'id', cityName],
    'paint': {
      'line-color': cityColor,
      'line-width': 2,
      'line-opacity': 1,
    },
  };

  let congressionalLayer = {
    'id': 'congressional-fill-layer',
    'type': 'line',
    'source': 'composite',
    'source-layer': CONGRESSIONAL_LAYER,
    'filter': ['==', 'id', lookup['congressional']],
    'paint': {
      'line-color': congressionalColor,
      'line-width': 2,
      'line-opacity': 1,
    },
  };

  let supervisorsLayer = {
    'id': 'supe-fill-layer',
    'type': 'line',
    'source': 'composite',
    'source-layer': SUPERVISORS_LAYER,
    'filter': ['==', 'id', lookup['supervisors']],
    'paint': {
      'line-color': countyColor,
      'line-width': 2,
      'line-opacity': 1,
    },
  };
  let staticURLsDict = {
    city: `https://api.mapbox.com/styles/v1/latimes/${mapboxStyle}/static/${marker}(${coordinates})/[${cityBoundaries}]/${mapWidth}x${mapHeight}@2x?access_token=${api}&addlayer=${encodeURIComponent(
      JSON.stringify(cityBoundariesLayer)
    )}&before_layer=bridge-street-minor-low&padding=${padding}`,
    congressional: `https://api.mapbox.com/styles/v1/latimes/${mapboxStyle}/static/${marker}(${coordinates})/[${congressionalBoundaries}]/${mapWidth}x${mapHeight}@2x?access_token=${api}&addlayer=${encodeURIComponent(
      JSON.stringify(congressionalLayer)
    )}&before_layer=bridge-street-minor-low&padding=${padding}`,
    supervisors: `https://api.mapbox.com/styles/v1/latimes/${mapboxStyle}/static/${marker}(${coordinates})/[${supervisorsBoundaries}]/${mapWidth}x${mapHeight}@2x?access_token=${api}&addlayer=${encodeURIComponent(
      JSON.stringify(supervisorsLayer)
    )}&before_layer=bridge-street-minor-low&padding=${padding}`,
  };

  //console.log(staticURLsDict);
  return staticURLsDict;
}
